import { isTrackingQueryParam } from '~/utility/query-params';

export const useFilterParser = (data: any) => {
  const {
    parent, q, category, sub_category, snp, provider_ids, providers, loc_id, location_id, provider_text, max_distance,
    min_catalog_count, min_catalog_rating, is_open_now, is_deliverable, provider_sort,
    min_price, max_price, food_type, is_stock_available, is_cancellable, is_returnable,
    min_discount_percentage, catalog_text, catalog_sort, prefill_category, ...rest
  } = data;

  const provider: any = {
    ...(parent && { categories: [useCategoryMaster(parent)] }),
    ...(q && { sub_categories: [q] }),
    ...(category && { categories: [category] }),
    ...(sub_category && { sub_categories: [sub_category] }),
    ...(snp && { seller_np_ids: [snp] }),
    ...(provider_ids && { provider_ids: [provider_ids] }),
    ...(providers && { providers: [providers] }),
    ...(loc_id && { location_ids: [loc_id] }),
    ...(location_id && { location_ids: [location_id] }),
    ...(max_distance && { max_distance }),
    ...(min_catalog_count && { min_catalog_count }),
    ...(min_catalog_rating && { min_catalog_rating }),
    ...(is_open_now && { is_open_now }),
    ...(is_deliverable && { is_deliverable }),
    ...(provider_text && { search_text: provider_text }),
    ...(provider_sort && { sort: provider_sort })
  };

  const cleanObject = Object.fromEntries(
    Object.entries(rest)
      .filter(([key, value]) =>
        !isTrackingQueryParam(key) && value != null
      )
      .map(([key, value]) => [key.toLowerCase(), [value?.toString().toLowerCase()]])
  );


  const catalog: any = {
    ...(min_price || max_price) && {
      price: [
        Number(min_price) || 0, 
        max_price !== undefined ? Number(max_price) : 50000
      ]
    },
    ...(food_type && { food_type }),
    ...(is_stock_available && { is_stock_available }),
    ...(is_cancellable && { is_cancellable }),
    ...(is_returnable && { is_returnable }),
    ...(min_discount_percentage && { min_discount_percentage }),
    ...(catalog_text && { search_text: catalog_text }),
    ...(catalog_sort && { sort: catalog_sort }),
    ...cleanObject
  };

  return { provider, catalog };
};
